import { render, staticRenderFns } from "./NavigationList.vue?vue&type=template&id=f51d812a&"
import script from "./NavigationList.ts?vue&type=script&lang=ts&"
export * from "./NavigationList.ts?vue&type=script&lang=ts&"
import style0 from "./NavigationList.scss?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports